import api from './api';
import { ClientListResponse, ClientDetailResponse, ClientFormData } from '../types/client';

let clientsCache: ClientListResponse | null = null;
let clientsCacheTimestamp = 0;
const CACHE_DURATION = 30000; // 30 seconds

// GET /api/site/clients?page=1&limit=10&search=...
export const clientService = {
    list: async (params?: {
        page?: number;
        limit?: number;
        search?: string;
    }): Promise<ClientListResponse> => {
        // Simple cache for the common "list all" call (limit 500/search empty)
        const isListAll = (!params?.search) && (params?.limit && params.limit >= 500);
        const now = Date.now();

        if (isListAll && clientsCache && (now - clientsCacheTimestamp < CACHE_DURATION)) {
            return clientsCache;
        }

        const response = await api.get('clients', { params });
        const data = response.data;

        if (isListAll) {
            clientsCache = data;
            clientsCacheTimestamp = now;
        }

        return data;
    },

    // GET /api/site/clients/:id
    getById: async (id: string): Promise<ClientDetailResponse> => {
        const response = await api.get(`clients/${id}`);
        return response.data;
    },

    // POST /api/site/clients
    create: async (data: ClientFormData): Promise<ClientDetailResponse> => {
        const response = await api.post('clients', data);
        return response.data;
    },

    // PUT /api/site/clients/:id
    update: async (id: string, data: Partial<ClientFormData>): Promise<ClientDetailResponse> => {
        const response = await api.put(`clients/${id}`, data);
        return response.data;
    },

    // DELETE /api/site/clients/:id  (soft delete)
    delete: async (id: string): Promise<{ success: boolean; message?: string }> => {
        const response = await api.delete(`clients/${id}`);
        return response.data;
    },

    // PATCH /api/site/clients/:id/toggle
    toggleStatus: async (id: string): Promise<ClientDetailResponse> => {
        const response = await api.patch(`clients/${id}/toggle`);
        return response.data;
    },
};
